import { forwardRef, useState } from 'react';
import { Box } from '@zoopla-eng/zds/box';
import { InputField, InputFieldProps } from '@zoopla-eng/zds/input-field';
import { buttonWithWidth } from './InputPassword.styles.css';
import { Button } from '@zoopla-eng/zds/button';

type InputPasswordProps = {
    helpText?: string;
    label?: string;
} & Omit<InputFieldProps, 'label' | 'type'>;

export const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
    ({ name, label, ...props }, ref) => {
        const [passwordHidden, setPasswordHidden] = useState(true);

        return (
            <Box>
                <InputField
                    {...props}
                    label={label || 'Password'}
                    type={passwordHidden ? 'password' : 'text'}
                    name={name}
                    button={
                        <div className={buttonWithWidth}>
                            <Button
                                type="button"
                                category="tertiary"
                                aria-label="Show/Hide Password"
                                aria-pressed={passwordHidden ? 'false' : 'true'}
                                onClick={() =>
                                    setPasswordHidden((prevState) => !prevState)
                                }
                                fw
                            >
                                <span
                                    data-testid={
                                        passwordHidden
                                            ? 'eye-open'
                                            : 'eye-closed'
                                    }
                                >
                                    {passwordHidden ? 'Show' : 'Hide'}
                                </span>
                            </Button>
                        </div>
                    }
                    ref={ref}
                />
            </Box>
        );
    }
);
